import React from 'react';

import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';

import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';
import { useContentComponentContext } from '../../../hooks/useContentComponentContext';
import { useAnalyticsFlowEventsQueue } from '../../../utils/analytics/analyticsFlowUtils';
import type { ErrorInfo } from '../../../utils/error-handling';
import { ErrorMessage } from '../../../utils/error-handling';
import { FAILURE_REASON } from '../../../utils/errors';
import { type ContextStatistics } from '../../../utils/xstate/get-ai-experience-service';

export function InvalidInputScreenWithLogic({
	errorInfo,
	contextStatistics,
}: {
	contextStatistics?: ContextStatistics;
	errorInfo: ErrorInfo;
}) {
	const aiExperienceCommonData = useAIExperienceCommonDataContext();
	const { endExperience } = aiExperienceCommonData;

	const { isInDocumentStreamingEnabled } = useContentComponentContext();

	useAnalyticsFlowEventsQueue({
		stepName: 'invalidInput',
		attributes: {
			reason: errorInfo.failureReason ?? FAILURE_REASON.UNKNOWN,
			modelIO: {
				contextStatistics,
			},
		},
	});

	return (
		<ErrorScreen
			text={ErrorMessage(errorInfo)}
			onCancel={() => {
				endExperience();
			}}
			isAIFC={isInDocumentStreamingEnabled}
		/>
	);
}
